module.exports = __webpack_public_path__ + "static/media/squirrel.a6ceeda9.svg";